import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.timers";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import merge from './merge';
import PopupManager from './popupManager';
var idSeed = 1;
var transitions = [];

var hookTransition = function hookTransition(transition) {
  if (transitions.indexOf(transition) !== -1) {
    return;
  } // @ts-ignore


  var getVueInstance = function getVueInstance(element) {
    var instance = element.__vue__;

    if (!instance) {
      var textNode = element.previousSibling;

      if (textNode.__vue__) {
        instance = textNode.__vue__;
      }
    }

    return instance;
  }; // 这个是什么函数
  // @ts-ignore


  Vue.transition(transition, {
    // @ts-ignore
    afterEnter: function afterEnter(el) {
      var instance = getVueInstance(el);

      if (instance && instance.doAfterOpen) {
        instance.doAfterOpen();
      }
    },
    // @ts-ignore
    afterLeave: function afterLeave(el) {
      var instance = getVueInstance(el);

      if (instance && instance.doAfterClose) {
        instance.doAfterClose();
      }
    }
  });
}; // @ts-ignore


var scrollBarWidth;

var getScrollBarWidth = function getScrollBarWidth() {
  if (Vue.prototype.$isServer) {
    return;
  } // @ts-ignore


  if (scrollBarWidth !== undefined) {
    // @ts-ignore
    return scrollBarWidth;
  }

  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
};

var getDOM = function getDOM(dom) {
  if (dom.nodeType === 3) {
    // @ts-ignore
    dom = dom.nextElementSibling || dom.nextSibling;
    getDOM(dom);
  }

  return dom;
};

var Popup =
/** @class */
function (_super) {
  __extends(Popup, _super);

  function Popup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.opened = false;
    _this.bodyOverflow = null;
    _this.bodyPaddingRight = null;
    _this.rendered = false;
    return _this;
  }

  Popup.prototype.onPopupValueChange = function (val) {
    var _this = this;

    if (val) {
      if (this._opening) {
        return;
      }

      if (!this.rendered) {
        this.rendered = true;
        Vue.nextTick(function () {
          _this.open();
        });
      } else {
        this.open();
      }
    } else {
      this.close();
    }
  };

  Popup.prototype.open = function (options) {
    var _this = this;

    if (!this.rendered) {
      this.rendered = true;
      this.$emit('input', true);
    }

    var props = merge({}, this, options, this.$props);

    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    clearTimeout(this._openTimer);
    var openDelay = Number(props.openDelay);

    if (openDelay > 0) {
      this._openTimer = setTimeout(function () {
        _this._openTimer = null;

        _this.doOpen(props);
      }, openDelay);
    } else {
      this.doOpen(props);
    }
  };

  Popup.prototype.doOpen = function (props) {
    if (this.$isServer) {
      return;
    }

    if (this.willOpen && !this.willOpen()) {
      return;
    }

    if (this.opened) {
      return;
    }

    this._opening = true; // 使用 vue-popup 的组件，如果需要和父组件通信显示的状态，应该使用 value，它是一个 prop，
    // 这样在父组件中用 v-model 即可；否则可以使用 visible，它是一个 data

    this.visible = true;
    this.$emit('input', true); // @ts-ignore

    var dom = getDOM(this.$el);
    var modal = props.modal;
    var zIndex = props.zIndex;

    if (zIndex) {
      PopupManager.zIndex = zIndex;
    }

    if (modal) {
      if (this._closing) {
        PopupManager.closeModal(this._popupId);
        this._closing = false;
      }

      PopupManager.openModal(this._popupId, PopupManager.nextZIndex(), dom, props.modalClass, props.modalFade);

      if (props.lockScroll) {
        if (!this.bodyOverflow) {
          // @ts-ignore
          this.bodyPaddingRight = document.body.style.paddingRight; // @ts-ignore

          this.bodyOverflow = document.body.style.overflow;
        }

        scrollBarWidth = getScrollBarWidth(); // @ts-ignore

        var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;

        if (scrollBarWidth > 0 && bodyHasOverflow) {
          document.body.style.paddingRight = scrollBarWidth + 'px';
        }

        document.body.style.overflow = 'hidden';
      }
    }

    if (getComputedStyle(dom).position === 'static') {
      dom.style.position = 'absolute';
    }

    dom.style.zIndex = String(PopupManager.nextZIndex());
    this.opened = true;

    if (this.onOpen) {
      this.onOpen();
    }

    if (!this.transition) {
      this.doAfterOpen();
    }
  };

  Popup.prototype.doAfterOpen = function () {
    this._opening = false;
  };

  Popup.prototype.close = function () {
    var _this = this;

    if (this.willClose && !this.willClose()) {
      return;
    }

    if (this._openTimer !== null) {
      clearTimeout(this._openTimer);
      this._openTimer = null;
    }

    clearTimeout(this._closeTimer);
    var closeDelay = Number(this.closeDelay);

    if (closeDelay > 0) {
      this._closeTimer = setTimeout(function () {
        _this._closeTimer = null;

        _this.doClose();
      }, closeDelay);
    } else {
      this.doClose();
    }
  };

  Popup.prototype.doClose = function () {
    var _this = this;

    this.visible = false;
    this.$emit('input', false);
    this._closing = true;

    if (this.onClose) {
      this.onClose();
    }

    if (this.lockScroll) {
      setTimeout(function () {
        if (_this.modal && _this.bodyOverflow !== 'hidden') {
          document.body.style.overflow = _this.bodyOverflow;
          document.body.style.paddingRight = _this.bodyPaddingRight;
        }

        _this.bodyOverflow = null;
        _this.bodyPaddingRight = null;
      }, 200);
    }

    this.opened = false;

    if (!this.transition) {
      this.doAfterClose();
    }
  };

  Popup.prototype.doAfterClose = function () {
    PopupManager.closeModal(this._popupId);
    this._closing = false;
  };

  Popup.prototype.created = function () {
    if (this.transition) {
      hookTransition(this.transition);
    }
  };

  Popup.prototype.beforeMount = function () {
    this._popupId = 'popup-' + idSeed++;
    PopupManager.register(this._popupId, this);
  };

  Popup.prototype.beforeDestroy = function () {
    PopupManager.deregister(this._popupId);
    PopupManager.closeModal(this._popupId);

    if (this.modal && this.bodyOverflow !== null && this.bodyOverflow !== 'hidden') {
      document.body.style.overflow = this.bodyOverflow;
      document.body.style.paddingRight = this.bodyPaddingRight;
    }

    this.bodyOverflow = null;
    this.bodyPaddingRight = null;
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], Popup.prototype, "value", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], Popup.prototype, "transition", void 0);

  __decorate([Prop({})], Popup.prototype, "openDelay", void 0);

  __decorate([Prop({})], Popup.prototype, "closeDelay", void 0);

  __decorate([Prop({})], Popup.prototype, "zIndex", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], Popup.prototype, "modal", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], Popup.prototype, "modalFade", void 0);

  __decorate([Prop({})], Popup.prototype, "modalClass", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], Popup.prototype, "lockScroll", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], Popup.prototype, "closeOnPressEscape", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], Popup.prototype, "closeOnClickModal", void 0);

  __decorate([Watch('value')], Popup.prototype, "onPopupValueChange", null);

  Popup = __decorate([Component({})], Popup);
  return Popup;
}(Vue);

export default Popup;
export { PopupManager };